var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDe1B27944D8F96Be116E49Ffc47D6877Ff61E3Fa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 22.5 46.5001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7143 0.541713C22.6578 1.35041 22.767 2.77084 21.9583 3.71432L5.21342 23.25L21.9583 42.7858C22.767 43.7292 22.6578 45.1497 21.7143 45.9584C20.7708 46.7671 19.3504 46.6578 18.5417 45.7143L0.541673 24.7143C-0.180558 23.8717 -0.180558 22.6284 0.541673 21.7858L18.5417 0.78576C19.3504 -0.157723 20.7708 -0.266986 21.7143 0.541713Z",
    fill: "var(--fill-0, white)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe1B27944D8F96Be116E49Ffc47D6877Ff61E3Fa);
export default __webpack_public_path__ + "static/media/de1b27944d8f96be116e49ffc47d6877ff61e3fa.df03c4ca885bf8a80b0f21a806662bca.svg";
export { ForwardRef as ReactComponent };